<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست نظرسنجی ها</h1>
          <b-row>
            <b-col cols="12" md="6">
              <div
                class="d-flex flex-column flex-md-row align-items-center justify-content-end"
              >
                <b-form-group
                  class="d-inline-block w-100 mr-md-2"
                  label="جستجوی عنوان"
                  label-for="searchCommand"
                >
                  <b-form-input
                    id="searchCommand"
                    v-model="searchParam"
                    class="d-inline-block"
                    placeholder="نحوه تدریس..."
                    @keydown.enter="getSurveysList"
                  />
                </b-form-group>
                <b-button
                  variant="primary"
                  class="ml-1 mb-2 mb-md-0"
                  @click="getSurveysList"
                >
                  اعمال
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-table
                ref="refUserListTable"
                class="position-relative"
                :items="surveyList"
                responsive
                :fields="myTableColumns"
                primary-key="id"
                show-empty
                bordered
                striped
                empty-text="موردی موجود نیست!"
              >
                <template #cell(isActive)="data">
                  <b-badge
                    :variant="data.item.isActive ? 'success' : 'danger'"
                    class="font-weight-normal"
                  >
                    {{ data.item.isActive ? "فعال" : "غیر فعال" }}
                  </b-badge>
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex align-items-center">
                    <b-link :to="`/apps/surveys/${data.item.surveyId}`">
                      <feather-icon icon="EditIcon" size="20" />
                    </b-link>
                    <feather-icon
                      v-b-modal.modal-delete
                      @click="setTempSurvey(data.item)"
                      icon="Trash2Icon"
                      size="20"
                      class="text-danger cursor-pointer ml-2"
                    />
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-center py-2"
            >
              <b-pagination
                v-model="pageNumber"
                :total-rows="totalCount"
                :per-page="count"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      title="حذف نظرسنجی"
      id="modal-delete"
      centered
      ok-title="بله"
      cancelTitle="خیر"
      @ok="deleteASingleSurvey"
    >
      <b-container>
        <span v-if="tempSurvey">
          آیا از حذف نظرسنجی با عنوان
          <strong>
            {{ tempSurvey.tilte }}
          </strong>
          اطمینان دارید؟
        </span>
      </b-container>
    </b-modal>
  </b-overlay>
</template>

<script>
export default {
  watch: {
    pageNumber: {
      handler(val) {
        this.getSurveysList();
      },
    },
  },
  mounted() {
    this.getSurveysList();
  },
  data() {
    return {
      isLoading: false,
      pageNumber: 1,
      count: 10,
      searchParam: null,
      totalCount: null,
      surveyList: null,
      tempSurvey: null,
      myTableColumns: [
        {
          key: "surveyId",
          label: "شناسه نظرسنجی",
        },
        {
          key: "tilte",
          label: "عنوان نظرسنجی",
        },
        {
          key: "isActive",
          label: "وضعیت نظرسنجی",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    setTempSurvey(survey) {
      this.tempSurvey = JSON.parse(JSON.stringify(survey));
    },
    async deleteASingleSurvey() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteASurvey = new DeleteASurvey(_this);
        deleteASurvey.setRequestParam({ surveyId: _this.tempSurvey.surveyId });
        await deleteASurvey.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "Trash2Icon",
                variant: "success",
                text: "نظرسنجی با موفقیت حذف شد.",
              },
            });
            _this.getSurveysList();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getSurveysList() {
      try {
        this.isLoading = true;
        let qParams = {
          pageNumber: this.pageNumber,
          count: this.count,
        };
        if (this.searchParam) {
          qParams["search"] = this.searchParam;
        }
        let _this = this;
        let getAllSurveys = new GetAllSurveys(_this);
        getAllSurveys.setRequestParam(qParams);
        await getAllSurveys.fetch((res) => {
          _this.surveyList = res.result.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
  },
};
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
import { GetAllSurveys, DeleteASurvey } from "@/libs/Api/Survey";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
